import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Art } from './Art';
const ridges = (x, y, w, h)=>Array.from({
        length: Math.floor(w / 6) - 1
    }, (_, i)=>`M${x + 6 * (i + 1)} ${y + 3}v${h - 6}`).join('');
/** A box at the edge of a stack of shipping containers. */ function Box({ x, y, fill }) {
    return /*#__PURE__*/ _jsxs("g", {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                className: fill,
                x: x,
                y: y,
                width: "40",
                height: "20",
                rx: "1"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "thin",
                d: ridges(x, y, 40, 20),
                opacity: ".45"
            })
        ]
    });
}
/**
 * A container port: a quay crane lifting a box off the quay beside a stack of containers,
 * water below. 240 × 140.
 */ export function PortContainer({ title, className }) {
    return /*#__PURE__*/ _jsxs(Art, {
        viewBox: "0 0 240 140",
        title: title,
        className: className,
        children: [
            /*#__PURE__*/ _jsx("path", {
                className: "fs n",
                d: "M0 112h240v28H0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "sa thin",
                d: "M14 124c6-3 12 3 18 0M92 130c6-3 12 3 18 0M170 122c6-3 12 3 18 0"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fh",
                d: "M-2 100h244v12H-2Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fa",
                d: "M40 100V36h5v64ZM74 100V36h5v64Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "sa thin",
                d: "m45 46 29 18M74 46 45 64M45 70l29 18M74 70 45 88",
                opacity: ".7"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fa",
                d: "M18 28h128c1.4 0 2 .8 2 2v6H18Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fp",
                d: "M62 36h14v10H62Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fa n",
                d: "M65 39h8v3h-8Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "sa",
                d: "M120 36v20M114 56h12"
            }),
            /*#__PURE__*/ _jsx(Box, {
                x: 100,
                y: 56,
                fill: "fb"
            }),
            /*#__PURE__*/ _jsx(Box, {
                x: 150,
                y: 80,
                fill: "fa"
            }),
            /*#__PURE__*/ _jsx(Box, {
                x: 192,
                y: 80,
                fill: "fo"
            }),
            /*#__PURE__*/ _jsx(Box, {
                x: 150,
                y: 60,
                fill: "fc"
            }),
            /*#__PURE__*/ _jsx(Box, {
                x: 192,
                y: 60,
                fill: "fb"
            }),
            /*#__PURE__*/ _jsx(Box, {
                x: 171,
                y: 40,
                fill: "fa2"
            })
        ]
    });
}
